// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuperAdminUserSessions .table-responsive {
  overflow: visible;
}

.SuperAdminUserSessions .react-datepicker-popper {
  z-index: 10000 !important;
}

.SuperAdminUserSessionsInfo {
  margin-bottom: 12px;
}

.SuperAdminUserSessionsDeleteSummary {
  background: #f8f9fa;
  border: 1px solid #e3e6ea;
  border-radius: 4px;
  padding: 10px 12px;
}

.SuperAdminUserSessionsDeleteSummary div {
  margin-bottom: 4px;
}

.SuperAdminUserSessionsDeleteSummary code {
  word-break: break-all;
  white-space: normal;
}

.SuperAdminUserSessionsDeleteItem {
  border-top: 1px solid #e3e6ea;
  margin-top: 8px;
  padding-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/views/SuperAdminApp/User/Sessions/SuperAdminUserSessions.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".SuperAdminUserSessions .table-responsive {\n  overflow: visible;\n}\n\n.SuperAdminUserSessions .react-datepicker-popper {\n  z-index: 10000 !important;\n}\n\n.SuperAdminUserSessionsInfo {\n  margin-bottom: 12px;\n}\n\n.SuperAdminUserSessionsDeleteSummary {\n  background: #f8f9fa;\n  border: 1px solid #e3e6ea;\n  border-radius: 4px;\n  padding: 10px 12px;\n}\n\n.SuperAdminUserSessionsDeleteSummary div {\n  margin-bottom: 4px;\n}\n\n.SuperAdminUserSessionsDeleteSummary code {\n  word-break: break-all;\n  white-space: normal;\n}\n\n.SuperAdminUserSessionsDeleteItem {\n  border-top: 1px solid #e3e6ea;\n  margin-top: 8px;\n  padding-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
